export default __webpack_public_path__ + "static/media/txt_entrance_07.f87b06fd.svg";